import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Dbattrs } from '../../core/entities/dbattrs.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class DbattrsService {
    readonly BASE: any = PETICIONES.dbattrs;

    constructor(private http: HttpClient) { }

  /**
   * @description
   * Obtiene todos los dbattrs
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un dbattrs por su id
   */
  public findById(id: number): Observable<any> {
    let idDbattrs: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idDbattrs).pipe(delay(DELAY));
  }

  /**
   * @description
   * Guarda un dbattrs en la base de datos
   */
  public postDbattr(dbattrs: Dbattrs): Observable<any> {
    const json = JSON.stringify(dbattrs);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postDbattrs, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Borra un dbattrs en la base de datos
   */
  public deleteDbattr(dbattrs: Dbattrs): Observable<any> {
    let iddbattrs: string = (dbattrs.id !== undefined && dbattrs.id !== null ? dbattrs.id + "" : "");
    return this.http.get(this.BASE.deleteDbattrs + "/" + iddbattrs).pipe(delay(DELAY));
  }

}